import { render, staticRenderFns } from "./_download.vue?vue&type=template&id=309bfde4&scoped=true&lang=pug&"
import script from "./_download.vue?vue&type=script&lang=js&"
export * from "./_download.vue?vue&type=script&lang=js&"
import style0 from "./_download.vue?vue&type=style&index=0&id=309bfde4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309bfde4",
  null
  
)

export default component.exports